module.exports = __webpack_public_path__ + "static/media/profilePictureBg.5e809df2.png";